<nz-range-picker
  [nzFormat]="dateFormat"
  [nzPlaceHolder]="[
  ('chart.startDate' | translate), 
  ('chart.endDate' | translate)
]"
  [(ngModel)]="dateRange"
  (ngModelChange)="onDateRangeChange($event)"
  nzSize="large"
>
</nz-range-picker>

<div class="chart-container">
  <canvas baseChart [data]="chartDataConfig" [options]="chartOptions" [type]="chartType" [legend]="showLegend">
  </canvas>
</div>
